// extracted by mini-css-extract-plugin
module.exports = {"notificationBell":"Notification_notificationBell__11p5D"};